import { render } from "./ThreeRandselBack.vue?vue&type=template&id=211a29ed&ts=true"
import script from "./ThreeRandselBack.vue?vue&type=script&lang=ts"
export * from "./ThreeRandselBack.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/gerald/Projects/designium/RandselSimulation/vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__